export default ({ eventBus, eventDefinitions, context }) => {
  eventBus.$on(eventDefinitions.SEARCH.PAGE_VIEW, ({ query, productsCount }) => {
    window.dataLayer.push({
      event: eventDefinitions.SEARCH.PAGE_VIEW,
      productsCount,
      query,
    })
  })
}
